import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function Navigation({ scrollToAbout, scrollToPendidikan, scrollToPengalaman, scrollToSkill, scrollToPortofolio }) {
    let activeLink = "text-white font-semibold no-underline py-2 px-4 bg-white bg-opacity-20 rounded-lg backdrop-blur-sm";
    let link = "text-white no-underline hover:text-white py-2 px-4 transition-all duration-300 hover:scale-105 hover:bg-white hover:bg-opacity-10 rounded-lg";

    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    return (
        <div className="p-5 md:p-11 sticky top-0 z-50 bg-gradient-primary md:rounded-b-none md:rounded-t-lg backdrop-blur-md shadow-lg animate-fade-in-down">
            <div className="flex justify-between items-center">
                <div className="hidden lg:block text-white">
                    <h1 className="font-bold text-2xl tracking-tight">Curriculum Vitae</h1>
                    <div className="w-full pt-3 border-b-2 border-white opacity-75"></div>
                </div>

                {/* Desktop Menu */}
                <div className="hidden lg:mx-0 lg:flex gap-2">
                    <NavLink to="/about" className={({ isActive }) => isActive ? activeLink : link}>Profil</NavLink>
                    <NavLink to="/pendidikan" className={({ isActive }) => isActive ? activeLink : link}>Pendidikan</NavLink>
                    <NavLink to="/pengalaman" className={({ isActive }) => isActive ? activeLink : link}>Pengalaman</NavLink>
                    <NavLink to="/skill" className={({ isActive }) => isActive ? activeLink : link}>Kemampuan</NavLink>
                    <NavLink to="/portofolio" className={({ isActive }) => isActive ? activeLink : link}>Portofolio</NavLink>
                </div>

                {/* Tablet Menu */}
                <div className="md:mx-auto hidden md:flex lg:hidden md:flex-row md:flex-wrap gap-2">
                    <button onClick={scrollToAbout} className={link}>Profil</button>
                    <button onClick={scrollToPendidikan} className={link}>Pendidikan</button>
                    <button onClick={scrollToPengalaman} className={link}>Pengalaman</button>
                    <button onClick={scrollToSkill} className={link}>Kemampuan</button>
                    <button onClick={scrollToPortofolio} className={link}>Portofolio</button>
                </div>

            </div>

            <div className="md:hidden relative flex justify-center text-left">
                <div>
                    <button
                        type="button"
                        className="inline-flex justify-between w-72 gap-x-1.5 rounded-full bg-white bg-opacity-20 backdrop-blur-sm text-white px-4 py-2.5 text-sm font-semibold shadow-lg hover:bg-opacity-30 focus:outline-none transition-all duration-300"
                        id="menu-button"
                        aria-expanded={isOpen}
                        aria-haspopup="true"
                        onClick={toggleDropdown}
                    >
                        <i className={`fa-solid ${isOpen ? 'fa-times' : 'fa-bars'} pt-0.5 transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}></i>
                        <p className="text-sm font-semibold">Curriculum Vitae</p>
                    </button>
                </div>

                {isOpen && (
                    <div
                        className="absolute top-12 mt-2 w-56 rounded-2xl bg-slate-700 text-white shadow-2xl backdrop-blur-lg animate-fade-in"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                    >
                        <div className="py-2 text-white" role="none">
                            <button onClick={() => { scrollToAbout(); setIsOpen(false); }} className="w-full text-left block px-5 py-3 text-sm hover:bg-white hover:bg-opacity-10 transition-all duration-300 rounded-lg mx-1">Tentang Saya</button>
                            <button onClick={() => { scrollToPendidikan(); setIsOpen(false); }} className="w-full text-left block px-5 py-3 text-sm hover:bg-white hover:bg-opacity-10 transition-all duration-300 rounded-lg mx-1">Pendidikan</button>
                            <button onClick={() => { scrollToPengalaman(); setIsOpen(false); }} className="w-full text-left block px-5 py-3 text-sm hover:bg-white hover:bg-opacity-10 transition-all duration-300 rounded-lg mx-1">Pengalaman</button>
                            <button onClick={() => { scrollToSkill(); setIsOpen(false); }} className="w-full text-left block px-5 py-3 text-sm hover:bg-white hover:bg-opacity-10 transition-all duration-300 rounded-lg mx-1">Kemampuan</button>
                            <button onClick={() => { scrollToPortofolio(); setIsOpen(false); }} className="w-full text-left block px-5 py-3 text-sm hover:bg-white hover:bg-opacity-10 transition-all duration-300 rounded-lg mx-1">Portofolio</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
export default Navigation;